import React, { useRef, useState } from 'react';
import { Modal, Button, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import RichTextEditor from '../../../components/RichTextEditor';

const AddAdvertisement = ({ open, handleClose, handleApply, edit = false, data = {} }) => {
    const file1Ref = useRef(null);
    const fileRef = useRef(null);
    const [formdata, setFormdata] = useState(data);
    const [newImageFile, setNewImageFile] = useState(null);
    const [newVideoFile, setNewVideoFile] = useState(null);

    const handleChange = (name, value) => {
        const omitSanitization = ['description'];
        let sanitizedValue = value;
        if (!omitSanitization.includes(name) && typeof value === 'string') {
            sanitizedValue = value.replace(/<\/?[^>]+(>|$)|[~`!<\>#$^{[}\]:;?+=_\|]|eval|windows/gi, '');
        }
        
        setFormdata((prev) => ({ ...prev, [name]: sanitizedValue }));
    };

    // const handleImageChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         setNewImageFile(file);
    //         handleChange('image', file);
    //     }
    // };

    // const handleFileChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         setNewVideoFile(file);
    //         handleChange('file', file);
    //     }
    // };
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes

const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
        if (file.size > MAX_FILE_SIZE) {
            alert("Image size must be less than or equal to 5 MB.");
            e.target.value = ""; // Reset file input
            return;
        }
        setNewImageFile(file);
        handleChange('image', file);
    }
};

const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
        if (file.size > MAX_FILE_SIZE) {
            alert("File size must be less than or equal to 5 MB.");
            e.target.value = ""; // Reset file input
            return;
        }
        setNewVideoFile(file);
        handleChange('file', file);
    }
};

    // const validate = (data) => {
        
    //     const requiredFields = {
    //         title: data.title?.trim(),
    //         description: data.description?.trim(),
    //         link: data.link?.trim(),
    //         status: data.status?.trim(),
    //     };

    //     if (!edit) {
    //         requiredFields.image = data.image instanceof File;
    //         requiredFields.file = data.file instanceof File;
    //     }

    //     if (Object.values(requiredFields).every(Boolean)) {
    //         handleApply(data);
    //     } else {
    //         alert('Please fill all details');
    //     }
    // };

//     const validate = (data) => {
//     const normalize = (val) => {
//         if (!val) return "";
//         if (typeof val !== "string") return String(val);

//         // clean up HTML-like strings similar to isDescriptionEmpty
//         const cleaned = val
//             .replace(/<p><\/p>/gi, "")
//             .replace(/<p><br><\/p>/gi, "")
//             .replace(/&nbsp;/gi, "")
//             .trim();

//         const div = document.createElement("div");
//         div.innerHTML = cleaned;
//         return (div.textContent || div.innerText || "").trim();
//     };

//     const requiredFields= {
//         title: normalize(data.title),
//         description: normalize(data.description),
//         link: normalize(data.link),
//         status: normalize(data.status),
//     };

//     // for create (not edit), ensure file/image exist
//     if (!edit) {
//         requiredFields.image = data.image instanceof File;
//         requiredFields.file = data.file instanceof File;
//     }

//     const isValid = Object.values(requiredFields).every(Boolean);

//     if (isValid) {
//         handleApply(data);
//     } else {
//         alert("Please fill all details");
//     }
// };
const validate = (data) => {
    const normalize = (val) => {
        if (!val) return "";
        if (typeof val !== "string") return String(val);

        const cleaned = val
            .replace(/<p><\/p>/gi, "")
            .replace(/<p><br><\/p>/gi, "")
            .replace(/&nbsp;/gi, "")
            .trim();

        const div = document.createElement("div");
        div.innerHTML = cleaned;
        return (div.textContent || div.innerText || "").trim();
    };

    // check normal required fields
    const requiredFields = {
        title: normalize(data.title),
        description: normalize(data.description),
        link: normalize(data.link),
        status: normalize(data.status),
    };

    // For create (not edit), require EITHER image OR file
    if (!edit) {
        const hasImage = data.image instanceof File;
        const hasFile = data.file instanceof File;

        if (!hasImage && !hasFile) {
            alert("Please upload either an Image or a Video file.");
            return;
        }
    }

    const isValid = Object.values(requiredFields).every(Boolean);

    if (isValid) {
        handleApply(data);
    } else {
        alert("Please fill all required details.");
    }
};

    return (
        <Modal isOpen={open} toggle={handleClose} size="lg" centered>
            <ModalHeader toggle={handleClose} className="d-flex justify-content-center">
                {edit ? 'Update Advertisement' : 'Add Advertisement'}
            </ModalHeader>
            <ModalBody>
                <Form inline onSubmit={(e) => e.preventDefault()}>
                    <FormGroup className="col-12 mb-2">
                        <Label className="col-4 d-flex justify-content-start" for="title">
                            Title
                        </Label>
                        <Input
                            className="col-8"
                            id="title"
                            type="text"
                            value={formdata?.title || ''}
                            onChange={(e) => handleChange('title', e.target.value)}
                        />
                    </FormGroup>

                    <FormGroup className="col-12 mb-2">
                        <Label className="col-4 d-flex justify-content-start mb-2">Description</Label>
                        <div className='col-12'>
                        <RichTextEditor
                            onEditorContentChange={(value) => handleChange('description', value)}
                            initialContent={formdata?.description ?? ''}
                        />
                        </div>
                    </FormGroup>

                    <FormGroup className="col-12 mb-2">
                        <Label className="col-4 d-flex justify-content-start" for="link">
                            Link
                        </Label>
                        <Input
                            className="col-8"
                            id="link"
                            type="text"
                            value={formdata?.link || ''}
                            onChange={(e) => handleChange('link', e.target.value)}
                        />
                    </FormGroup>

                    <FormGroup className="col-12 mb-2">
                        <Label className="col-4 d-flex justify-content-start" for="image">
                            Image
                        </Label>
                        <div className="col-md-8">
                            <input
                                id="image"
                                type="file"
                                ref={file1Ref}
                                accept="image/png, image/gif, image/jpeg"
                                style={{ display: edit ? 'none' : 'block' }}
                                onChange={handleImageChange}
                            />

                            {edit && (
                                <>
                                    {newImageFile ? (
                                        <span className="text-muted">Selected Image: {newImageFile.name}</span>
                                    ) : (
                                        typeof formdata?.image === 'string' && (
                                            <a
                                                href={formdata.image}
                                                download
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-outline-primary my-2">
                                                Download Current Image
                                            </a>
                                        )
                                    )}
                                    <Button
                                        type="button"
                                        color="secondary"
                                        onClick={() => file1Ref.current?.click()}
                                        className="my-2 ml-2">
                                        Change Image
                                    </Button>
                                </>
                            )}
                        </div>
                    </FormGroup>

                    <FormGroup className="col-12 mb-3">
                        <Label className="col-4 d-flex justify-content-start" for="file">
                            Upload File
                        </Label>
                        <div className="col-8">
                            <input
                                id="file"
                                type="file"
                                ref={fileRef}
                                accept="video/*"
                                style={{ display: edit ? 'none' : 'block' }}
                                onChange={handleFileChange}
                            />

                            {edit && (
                                <>
                                    {newVideoFile ? (
                                        <div className="mb-2">
                                            <strong>Selected File Preview:</strong>
                                            <video width="100%" height="auto" controls style={{ maxHeight: '200px' }}>
                                                <source
                                                    src={URL.createObjectURL(newVideoFile)}
                                                    type={newVideoFile.type}
                                                />
                                                Your browser does not support the video tag.
                                            </video>
                                            <span className="text-muted d-block mt-1">{newVideoFile.name}</span>
                                        </div>
                                    ) : (
                                        typeof formdata?.file === 'string' && (
                                            <div className="mb-2">
                                                <strong>Current File:</strong>
                                                <video
                                                    width="100%"
                                                    height="auto"
                                                    controls
                                                    style={{ maxHeight: '200px' }}>
                                                    <source src={formdata.file} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                                <span className="text-muted d-block mt-1">
                                                    {formdata.file.split('/').pop()}
                                                </span>
                                            </div>
                                        )
                                    )}

                                    <Button
                                        type="button"
                                        color="secondary"
                                        onClick={() => fileRef.current?.click()}
                                        className="my-2">
                                        Change File
                                    </Button>
                                </>
                            )}
                        </div>
                    </FormGroup>

                    <FormGroup className="col-12 mb-2">
                        <Label className="col-4 d-flex justify-content-start" for="status">
                            Status
                        </Label>
                        <Input
                            className="col-8"
                            id="status"
                            type="select"
                            value={formdata?.status || ''}
                            onChange={(e) => handleChange('status', e.target.value)}>
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </Input>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-end">
                <Button color="primary" onClick={() => validate(formdata)}>
                    {edit ? 'Update' : 'Create'}
                </Button>
                <Button className="btn btn-light text-secondary" onClick={handleClose}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AddAdvertisement;
